const TextArea = ({
  register, error, label, id, onChange, value, onBlur, onFocus, onKeyDown, ...inputProps
}) => (
  <textarea onBlur={onBlur} onKeyDown={onKeyDown} onFocus={onFocus} value={value} rows="2" maxLength="128" name={inputProps.name} onChange={onChange} className={inputProps.className} placeholder={inputProps.placeholder}>

  </textarea>
);

export default TextArea;
